import { z } from 'zod';

export const InviteNetworkUserBodySchema = z.object({
  email: z.email(),
  fullName: z.string().min(1),
  permissionGroupId: z.uuid(),
});

export type InviteNetworkUserBody = z.infer<typeof InviteNetworkUserBodySchema>;
